const Validation = {
    install(Vue, options) {
        Vue.prototype.$validation = {
            create: Validation.create
        }
    },
    create(fields) {
        _.each(fields, function (rules, field) {
            _.each(rules, function (rule, idx) {
                if (_.isString(rule)) {
                    fields[field][idx] = Validation.parseRule(rule);
                }
            })
        });
        return fields;
    },
    parseRule(rule) {
        //match name:params:msg pattern. All ':' in params must be escaped using '\'
        let matches = rule.match(/([^:]+)(?::(.*?[^\\])(?=:|$)(?::(.*))?)?$/);
        if (!matches || _.isEmpty(matches)) {
            console.error('Unable to parse rule: ' + rule);
        }

        let name = matches[1];
        let params = matches[2];
        let msg = matches[3];
        if (!_.has(Validation.rules, name)) {
            console.error('Unknown rule: ' + name);
            return '';
        }
        return Validation.rules[name](params, msg);
    },
    rules: {
        required(m) {
            return v => !!v || (m ? m : 'Dieses Feld ist ein Pflichtfeld');
        },
        requireBoolean(m) {
            return v => v !== undefined && v !== null || (m ? m : 'Dieses Feld ist ein Pflichtfeld');
        },
        requireMoney(m) {
            return v => !!v || (m ? m : 'Ungültiger Betrag');
        },
        requireNumber(m) {
            return v => !v || /^[0-9]+$/.test(v + '') || (m ? m : 'Nur Zahlen erlaubt');
        },
        requireMultiple(p, m) {
            return v => !!v && v.length >= p || (m ? m : 'Mindestens ' + p + ' auswählen');
        },
        email(m) {
            return v => !!v && /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(v) || (m ? m : 'Ungültige E-Mail');
        },
        between() {
        },
        requireTrue(m) {
            return v => v === true || (m ? m : 'Dieses Feld ist ein Pflichtfeld');
        },
        time(m) {
            return v => !v || /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/.test(v + '') || (m ? m : 'Uhrzeit muss zwischen zwischen 00:00 und 23:59 liegen');
        },
        dateAfter() {

        },
        dateBefore() {

        },
        minVal(p, m) {
            return v => !v && v !== 0 && v !== '0' || v >= p || (m ? m : 'Minimum ' + p);
        },
        maxVal(p, m) {
            return v => !v || v <= p || (m ? m : 'Maximum ' + p);
        },
        minLen() {

        },
        maxLen(p, m) {
            p = parseInt(p);
            return v => !v || v.length <= p || (m ? m : 'Höchstens ' + p + ' Zeichen');
        },
        length() {

        },
        match(p, m) {
            p = new RegExp('^' + p + '$');
            return v => p.test(v) || (m ? m : 'Ungültige Zeichen');
        },
        efn(p, m) {
            return (v) => {
                if (!v) {
                    return true
                }
                if (v === 'efn_backdoor') {
                    return true
                }
                let country = [
                    '276',
                    '040',
                    '756'];
                if (v.length === 15) {
                    for (let i = 0; i < 15; i++) {
                        if (!/^\d+$/.test(v)) {
                            return 'Ungültige EFN';
                        }
                    }
                    let tmp = v.substr(2, 3);
                    if (country.indexOf(tmp) !== -1) {
                        let sum = 0;
                        let numDigits = v.length - 1;
                        let parity = numDigits % 2;
                        for (let i = numDigits; i >= 0; i--) {
                            let digit = parseInt(v.substr(i, 1), 10);
                            if (parity !== (i % 2)) {
                                digit = digit << 1;
                            }
                            digit = (digit > 9) ? (digit - 9) : digit;
                            sum += digit;
                        }
                        return (0 === (sum % 10)) || 'Ungültige EFN'
                    }
                }
                return 'Ungültige EFN';
            }
        },
    },
};
export default Validation;
